export default {
  nav: {
    home: 'Faqja Kryesore',
    video: 'Vëzhgim me Video',
    alarm: 'Sistemet e Alarmit',
    solutions: 'Zgjidhjet',
    care: 'SSG Care',
    planner: 'Planifikuesi i Kamerave',
    areas: 'Zonat e Shërbimit',
    about: 'Rreth Nesh',
    contact: 'Kontakti',
  },
  dropdown: {
    allSolutions: 'Shiko të gjitha zgjidhjet',
    homeGrounds: 'Shtëpia dhe Prona',
    retailGastro: 'Tregtia dhe Gastronomia',
    officePractice: 'Zyra dhe Praktika',
    warehouseLogistics: 'Magazina dhe Logjistika',
    workshopTrade: 'Punishtja dhe Tregtia',
    apartments: 'Ndërtesat e Banesave dhe Pronat',
    cameraTypes: 'Llojet e Kamerave',
    services: 'Shërbimet',
    technology: 'Teknologjia',
  },
  footer: {
    brandLine: 'Teknologji sigurie për privatë dhe biznese',
    area: 'Hainburg · Rajoni Rhine-Main',
    services: 'Shërbimet',
    solutions: 'Zgjidhjet',
    forWhom: 'Për Kë',
    contact: 'Kontakti',
    areaLabel: 'Zona e shërbimit Rhine-Main',
    privateCustomers: 'Klientë privatë',
    businessCustomers: 'Klientë biznesi',
    allSolutions: 'Të gjitha zgjidhjet',
    faq: 'Pyetje të shpeshta',
    rights: 'Të gjitha të drejtat e rezervuara.',
    impressum: 'Impressum',
    privacy: 'Politika e privatësisë',
    cookieSettings: 'Cilësimet e cookies',
  },
  related: {
    eyebrow: 'Më shumë zgjidhje',
    title: 'Zbuloni lloje të tjera pronash',
    viewAll: 'Shiko të gjitha zgjidhjet',
  },
};